import React, { useState, useEffect } from "react";
import StreamAction, { StreamClose } from "../../../svg/StreamAction";
import StreamLine from "./../StreamLine";
import { Order } from "../../common/Order/ProgressOrder";
import { useDispatch, useSelector } from "react-redux";
import { setActiveStream } from "../../../entities/actions";
import { selectorGetActiveStream } from "../../../entities/selectors";
import { hexToRgb } from "../../../utils/hexToRgba";
import { config } from "../../../config";
import { NewOrder } from "../../common/Order/ProgressOrder/NewOrder";

const Stream = props => {
  const {
    start,
    streamData,
    stepStreams,
    currentTick,
    tickDuration,
    simulation,
    bgcolor = "#313c5d",
    actualOrders
  } = props;

  const dispatch = useDispatch();
  const [active, setActive] = useState(false);
  const [startStep, setStartStep] = useState(null);
  const [color, setColor] = useState(null);

  const [params, setParams] = useState({
    exec_rate: "",
    average_price: "",
    executed_qty: ""
  });
  const [orders, setOrders] = useState({
    buy: 0,
    sell: 0
  });

  useEffect(() => {
    if (streamData?.length && startStep === null)
      setStartStep(streamData[0].tp - 1);
  }, [streamData]);

  useEffect(() => {
    currentTick >= startStep &&
    currentTick < streamData[streamData?.length - 1]?.tp - 1
      ? setActive(true)
      : setActive(false);
    if (!color) setColor(bgcolor);

    setParams(prev => ({
      exec_rate: curStream?.exec_rate
        ? `${curStream?.exec_rate}%`
        : prev.exec_rate,
      average_price: curStepStream?.average_price
        ? curStepStream?.average_price
        : prev.average_price,
      executed_qty: curStepStream?.executed_qty
        ? curStepStream?.executed_qty
        : prev.executed_qty
    }));
  }, [currentTick]);

  const curStream = streamData?.find(el => el.tp - 1 === currentTick + 1);
  const curStepStream = stepStreams?.find(
    e => e.stream_id === streamData[0].sid
  );

  const activeStream = useSelector(selectorGetActiveStream);

  const showStreamsInfo = e => {
    if (e.target?.closest("div").id === activeStream) {
      dispatch(setActiveStream(null));
    } else {
      dispatch(setActiveStream(e.target?.closest("div").id));
    }
  };

  useEffect(() => {
    setOrders(prev => ({
      buy: curStepStream?.orders_by_side
        ? curStepStream?.orders_by_side?.BUY?.substr(3, 1)
        : prev.buy,
      sell: curStepStream?.orders_by_side
        ? curStepStream?.orders_by_side?.SELL?.substr(3, 1)
        : prev.sell
    }));
  }, [curStepStream]);

  const currentActualOrderSell = actualOrders?.find(
    ao => ao.order_id === curStepStream?.orders_by_side?.SELL
  );
  const currentActualOrderBuy = actualOrders?.find(
    ao => ao.order_id === curStepStream?.orders_by_side?.BUY
  );

  return (
    <div className="streams-table-item streams-table-item-opened">
      <div className="streams-table-item-first">
        <div
          className="streams-table-item-first-container"
          style={{
            opacity: active ? 1 : 0.4
          }}
        >
          <div
            style={{
              background: bgcolor,
              width: "5px",
              height: "100%"
            }}
          />
          <span className="match-stream-orders">
            <NewOrder
              key={`${orders.sell} BUY`}
              side="BUY"
              type={currentActualOrderBuy?.type}
              isActive={true}
              iconSize={21}
              num={orders.buy || ""}
              classname="stream-match-order"
            />
            <NewOrder
              key={`${orders.sell} SELL`}
              side="SELL"
              type={currentActualOrderSell?.type}
              isActive={true}
              iconSize={21}
              num={orders.sell || ""}
              classname="stream-match-order cover-order"
            />
          </span>
          <span className="rate-orders">{params?.exec_rate}</span>
          <span className="avg-price-orders">
            {params.average_price ? params.average_price.toFixed(2) : ""}
          </span>
          <span className="executed-qty-orders">{params?.executed_qty}</span>
        </div>
      </div>
      <div
        className="streams-table-item-second"
        style={{
          opacity: active ? 1 : 0.4
        }}
      >
        <StreamLine
          start={start}
          startStep={startStep}
          active={active}
          data={streamData}
          currentTick={currentTick}
          tickDuration={tickDuration}
          simulation={simulation}
          bgcolor={bgcolor}
        />
        <div className="streams-table-item-second-actions">
          <span
            className="streams-table-item-stream-number"
            style={{
              color: active ? "white" : "#888"
            }}
          >
            <div className="streams-table-item-stream-number-tint">
              {config.streams.title}
              <div
                className="stream-item-number-circle"
                style={{
                  background: bgcolor,
                  color: "white"
                }}
              >
                {streamData[0]?.sid.slice(3)}
              </div>
            </div>
          </span>
        </div>
      </div>
      <div className="streams-table-item-stream-action">
        <div className="stream-info-wrapper" onClick={showStreamsInfo}>
          <div id={streamData[0]?.sid}>
            {activeStream === streamData[0].sid ? (
              <StreamClose />
            ) : (
              config.streams.info
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default React.memo(Stream);
